import { register, mount } from 'riot'
import observable from '@riotjs/observable'
import MobileDetect from 'mobile-detect'
import SmartsearchLoader from 'loaders/smartsearch_loader'
import CategoryLoader from 'loaders/category_loader'
import Smartsearch from 'tags/smartsearch/smartsearch.riot'
import PriceCheckboxes from 'tags/smartsearch/price-checkboxes.riot'
import MaterialCheckboxes from 'tags/smartsearch/material-checkboxes.riot'
import StrapCheckboxes from 'tags/smartsearch/strap-checkboxes.riot'
import ColorCheckboxes from 'tags/smartsearch/color-checkboxes.riot'
import CasewidthCheckboxes from 'tags/smartsearch/casewidth-checkboxes.riot'
import GenderCheckboxes from 'tags/smartsearch/gender-checkboxes.riot'
import WaterproofsCheckboxes from 'tags/smartsearch/waterproofs-checkboxes.riot'
import MovementCheckboxes from 'tags/smartsearch/movement-checkboxes.riot'
import FunctionCheckboxes from 'tags/smartsearch/function-checkboxes.riot'
import SelectcategoryWindow from 'tags/smartsearch/selectcategory-window.riot'
import SearchCounter from 'tags/smartsearch/search-counter.riot'
import HeaderSearchbar from 'tags/smartsearch/header-searchbar.riot'

// updated at 2025-09-18
const initializeSmartsearch = () => {
  register('smartsearch', Smartsearch)
  register('price-checkboxes', PriceCheckboxes)
  register('material-checkboxes', MaterialCheckboxes)
  register('strap-checkboxes', StrapCheckboxes)
  register('color-checkboxes', ColorCheckboxes)
  register('casewidth-checkboxes', CasewidthCheckboxes)
  register('gender-checkboxes', GenderCheckboxes)
  register('waterproofs-checkboxes', WaterproofsCheckboxes)
  register('movement-checkboxes', MovementCheckboxes)
  register('function-checkboxes', FunctionCheckboxes)
  register('selectcategory-window', SelectcategoryWindow)
  register('search-counter', SearchCounter)
  register('header-searchbar', HeaderSearchbar)

  const md = new MobileDetect(window.navigator.userAgent)
  const isMobile = !!(md.phone())
  const loader = new SmartsearchLoader()
  const categoryLoader = new CategoryLoader()
  const observableInComponent = observable({})
  const mountedTag = mount('smartsearch', { loader: loader, categoryLoader: categoryLoader, mobile: isMobile, observable: observableInComponent })[0]
  observable(mountedTag)
  mountedTag.on('mounted', () => {
    console.log("mountedTag mounted")
  })
  mountedTag.one('updated', () => {
    console.log("mountedTag updated")
    mount('header-searchbar', { mobile: isMobile })
  })
  categoryLoader.loadRootAndBrandCategories()
}

if (document.readyState !== "loading") {
  initializeSmartsearch()
} else {
  document.addEventListener('DOMContentLoaded', initializeSmartsearch)
}
